import React from "react";
import myPhoto from "../assets/img/mfobe.png";
import { Container, Row, Col } from "react-bootstrap";
import { FaEnvelope, FaPhone, FaMapMarkerAlt, FaGithub, FaLinkedin } from "react-icons/fa";
import TrackVisibility from "react-on-screen";

export const Contact = () => {
  return (
    <section className="contact" id="connect">
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={4} className="d-flex justify-content-center justify-content-md-start mb-4 mb-md-0">
            <TrackVisibility>
              {({ isVisible }) => (
                <img
                  src={myPhoto}
                  alt="Mfobe Ntintelo"
                  className={`contact-photo img-fluid rounded shadow-lg ${
                    isVisible ? "animate__animated animate__zoomIn" : ""
                  }`}
                  style={{ maxWidth: "100%", borderRadius: "16px" }}
                />
              )}
            </TrackVisibility>
          </Col>

          <Col xs={12} md={8}>
            <div className="contact-info-box">
              <h1 className="contact-name mb-4">Mfobe Ntintelo</h1>

              <div className="contact-details mb-4">
                <p className="contact-item">
                  <FaEnvelope className="icon me-2" /> relelentintelo@gmail.com
                </p>
                <p className="contact-item">
                  <FaPhone className="icon me-2" /> +27 67 013 7413
                </p>
                <p className="contact-item">
                  <FaMapMarkerAlt className="icon me-2" /> Johannesburg, South Africa
                </p>
              </div>

              <div className="social-links mb-5">
                <a href="https://github.com/MfobesTechJournal" target="_blank" rel="noreferrer" className="contact-link me-4">
                  <FaGithub className="icon" /> GitHub
                </a>
                <a href="https://www.linkedin.com/in/mfobe-ntintelo-635440140/" target="_blank" rel="noreferrer" className="contact-link">
                  <FaLinkedin className="icon" /> LinkedIn
                </a>
              </div>

              <p className="contact-bio text-white lead" style={{ lineHeight: "1.8" }}>
                Full Stack Developer| Specialized in AI, Data Engineering, DevOps & Cloud | Building intelligent, scalable solutions.
              </p>

              <div className="mt-5">
                <a
                  href="public/pdfs/Mfobe-Ntintelo-Tech-CV-2025.pdf"
                  download="Mfobe-Ntintelo-Tech-CV-2025.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Download Mfobe Ntintelo CV"
                  className="btn rounded-pill px-5 py-3 fw-bold text-white d-inline-flex align-items-center gap-2"
                  
                  style={{
                    background: "linear-gradient(90deg, #667eea 0%, #764ba2 100%)",
                    border: "none",
                    boxShadow: "0 8px 25px rgba(102, 126, 234, 0.4)",
                    textDecoration: "none",
                  }}
                >
                  Download CV
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                    <polyline points="7 10 12 15 17 10" />
                    <line x1="12" y1="15" x2="12" y2="3" />
                  </svg>
                </a>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};